<template>
  <div class="l-page l-page--abtest-detail">
    <!-- サイドバーエリア -->
    <page-sidebar />
    <!-- /サイドバーエリア -->
    <main class="l-main">
      <!-- パンくずリスト -->
      <breadcrumb :breadcrumb-data="breadcrumbData" />
      <!-- /パンくずリスト -->
      <div class="l-main-content">
        <div class="p-abtest-detail">
          <!-- 基本情報 -->
          <div class="p-abtest-detail-list">
            <div class="c-loader c-loader"></div>
            <div class="p-abtest-detail-list__item">
              <h2 class="c-title u-w100p">
                <div class="c-title__text u-fs24">{{ abtest.abtest_name }}</div>
              </h2>
            </div>
            <div class="p-abtest-detail-list__item">
              <div class="p-abtest-detail__title">テスト項目</div>
              <div class="p-abtest-detail__text p-abtest-detail__text--type">{{ abtestInfo.abtestTypes[abtest.abtest_type] }}</div>
              <div class="p-abtest-detail__title">検証結果集計日</div>
              <div class="p-abtest-detail__text">{{ checkDate }}</div>
            </div>
            <div class="p-abtest-detail-list__item p-abtest-detail-list__item--desc">
              <div class="p-abtest-detail__title">テストした内容</div>
              <div class="p-abtest-detail__text">{{ abtest.memo }}</div>
            </div>
          </div>
          <div class="p-abtest-detail-result">
            <div class="c-loader c-loader"></div>
            <div class="p-abtest-detail-result__image">
              <div class="c-icon c-icon--yellow u-wh48">
                <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                  <use xlink:href="/assets/img/sprite.svg#crown" />
                </svg>
              </div>
            </div>
            <div class="p-abtest-detail-result-content">
              <div class="p-abtest-detail-result__title">A/Bテスト結果</div>
              <div v-if="(abtestResult.aWin == null)" class="p-abtest-detail-result__text">今回はAパターンとBパターンに有意差はありませんでした</div>
              <div v-else class="p-abtest-detail-result__text">今回は「{{ abtestResult.aWin ? 'A' : 'B' }}」パターンが勝利しました</div>
            </div>
          </div>
          <div v-if="(abtestResult.aWin == null)" class="p-abtest-detail-match">
            <div class="p-abtest-detail-match__item">
              <div class="p-abtest-detail-match__text">A</div>
            </div>
            <div class="p-abtest-detail-match__item">
              <div class="p-abtest-detail-match__text">B</div>
            </div>
          </div>
          <div v-else class="p-abtest-detail-match">
            <div
              class="p-abtest-detail-match__item "
              :class="{ 'p-abtest-detail-match__item--victory': abtestResult.aWin }"
            >
              <div class="p-abtest-detail-match__text">A</div>
            </div>
            <div
              class="p-abtest-detail-match__item"
              :class="{ 'p-abtest-detail-match__item--victory': !abtestResult.aWin }"
            >
              <div class="p-abtest-detail-match__text">B</div>
            </div>
          </div>
          <div v-if="(abtestResult.aWin == null)" class="p-abtest-detail-preview">
            <div class="p-abtest-detail-preview-list">
              <div class="p-abtest-detail-preview-list__item">
                <div class="p-message-preview">
                  <!--
                                    A/Bテスト: コンテンツ比較の配信テスト
                                -->
                  <div
                    v-if="abtestType == abtestInfo.abtestTypeValues.Message"
                    class="p-message-preview-list"
                  >
                    <message-preview
                      :title="messageA.message_title"
                      :text="messageA.message_text"
                      :url="messageA.click_url"
                      :icon-url="messageA.image_url"
                      :large-image-url="messageA.large_image_url"
                      :has-button-a="messageA.action_button_text_a != null"
                      :has-button-b="messageA.action_button_text_b != null"
                      :action-button-text-a="messageA.action_button_text_a"
                      :action-button-text-b="messageA.action_button_text_b"
                    />
                  </div>

                  <!--
                                    A/Bテスト: 属性別（デモグラフィック別）での配信テスト
                                -->
                  <demogra-table
                    v-if="abtestType == abtestInfo.abtestTypeValues.Demogra"
                    :topic-condition="topicConditionA"
                  />

                  <!--
                                    A/Bテスト: 曜日・時間帯での配信テスト
                                -->
                  <div
                    v-if="abtestType == abtestInfo.abtestTypeValues.Timezone"
                    class="p-abtest-edit-preview-list__item"
                  >
                    <div class="p-abtest-edit-preview-content">
                      <div class="p-abtest-edit-preview-content-row">
                        <div class="p-abtest-edit-preview-content__title">配信の設定</div>
                        <div class="p-abtest-edit-preview-content__text">予約配信</div>
                      </div>
                      <div class="p-abtest-edit-preview-content-row">
                        <div class="p-abtest-edit-preview-content__title">配信される日時</div>
                        <div class="p-abtest-edit-preview-content__text">{{ startDateTimeA }}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="p-abtest-detail-preview-list__item">
                <div class="p-message-preview">
                  <!--
                                    A/Bテスト: コンテンツ比較の配信テスト
                                -->
                  <div
                    v-if="abtestType == abtestInfo.abtestTypeValues.Message"
                    class="p-message-preview-list"
                  >
                    <message-preview
                      :title="messageB.message_title"
                      :text="messageB.message_text"
                      :url="messageB.click_url"
                      :icon-url="messageB.image_url"
                      :large-image-url="messageB.large_image_url"
                      :has-button-a="messageB.action_button_text_a != null"
                      :has-button-b="messageB.action_button_text_b != null"
                      :action-button-text-a="messageB.action_button_text_a"
                      :action-button-text-b="messageB.action_button_text_b"
                    />
                  </div>

                  <!--
                                    A/Bテスト: 属性別（デモグラフィック別）での配信テスト
                                -->
                  <demogra-table
                    v-if="abtestType == abtestInfo.abtestTypeValues.Demogra"
                    :topic-condition="topicConditionB"
                  />

                  <!--
                                    A/Bテスト: 曜日・時間帯での配信テスト
                                -->
                  <div
                    v-if="abtestType == abtestInfo.abtestTypeValues.Timezone"
                    class="p-abtest-edit-preview-list__item"
                  >
                    <div class="p-abtest-edit-preview-content">
                      <div class="p-abtest-edit-preview-content-row">
                        <div class="p-abtest-edit-preview-content__title">配信の設定</div>
                        <div class="p-abtest-edit-preview-content__text">予約配信</div>
                      </div>
                      <div class="p-abtest-edit-preview-content-row">
                        <div class="p-abtest-edit-preview-content__title">配信される日時</div>
                        <div class="p-abtest-edit-preview-content__text">{{ startDateTimeB }}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-else class="p-abtest-detail-preview">
            <div class="p-abtest-detail-preview-list">
              <div
                class="p-abtest-detail-preview-list__item"
                :class="{ 'p-abtest-detail-preview-list__item--victory': abtestResult.aWin }"
              >
                <div class="p-message-preview">
                  <!--
                                    A/Bテスト: コンテンツ比較の配信テスト
                                -->
                  <div
                    v-if="abtestType == abtestInfo.abtestTypeValues.Message"
                    class="p-message-preview-list"
                  >
                    <message-preview
                      :title="messageA.message_title"
                      :text="messageA.message_text"
                      :url="messageA.click_url"
                      :icon-url="messageA.image_url"
                      :large-image-url="messageA.large_image_url"
                      :has-button-a="messageA.action_button_text_a != null"
                      :has-button-b="messageA.action_button_text_b != null"
                      :action-button-text-a="messageA.action_button_text_a"
                      :action-button-text-b="messageA.action_button_text_b"
                    />
                  </div>

                  <!--
                                    A/Bテスト: 属性別（デモグラフィック別）での配信テスト
                                -->
                  <demogra-table
                    v-if="abtestType == abtestInfo.abtestTypeValues.Demogra"
                    :topic-condition="topicConditionA"
                  />

                  <!--
                                    A/Bテスト: 曜日・時間帯での配信テスト
                                -->
                  <div
                    v-if="abtestType == abtestInfo.abtestTypeValues.Timezone"
                    class="p-abtest-edit-preview-list__item"
                  >
                    <div class="p-abtest-edit-preview-content">
                      <div class="p-abtest-edit-preview-content-row">
                        <div class="p-abtest-edit-preview-content__title">配信の設定</div>
                        <div class="p-abtest-edit-preview-content__text">予約配信</div>
                      </div>
                      <div class="p-abtest-edit-preview-content-row">
                        <div class="p-abtest-edit-preview-content__title">配信される日時</div>
                        <div class="p-abtest-edit-preview-content__text">{{ startDateTimeA }}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="p-abtest-detail-preview-list__item"
                :class="{ 'p-abtest-detail-preview-list__item--victory': !abtestResult.aWin }"
              >
                <div class="p-message-preview">
                  <!--
                                    A/Bテスト: コンテンツ比較の配信テスト
                                -->
                  <div
                    v-if="abtestType == abtestInfo.abtestTypeValues.Message"
                    class="p-message-preview-list"
                  >
                    <message-preview
                      :title="messageB.message_title"
                      :text="messageB.message_text"
                      :url="messageB.click_url"
                      :icon-url="messageB.image_url"
                      :large-image-url="messageB.large_image_url"
                      :has-button-a="messageB.action_button_text_a != null"
                      :has-button-b="messageB.action_button_text_b != null"
                      :action-button-text-a="messageB.action_button_text_a"
                      :action-button-text-b="messageB.action_button_text_b"
                    />
                  </div>

                  <!--
                                    A/Bテスト: 属性別（デモグラフィック別）での配信テスト
                                -->
                  <demogra-table
                    v-if="abtestType == abtestInfo.abtestTypeValues.Demogra"
                    :topic-condition="topicConditionB"
                  />

                  <!--
                                    A/Bテスト: 曜日・時間帯での配信テスト
                                -->
                  <div
                    v-if="abtestType == abtestInfo.abtestTypeValues.Timezone"
                    class="p-abtest-edit-preview-list__item"
                  >
                    <div class="p-abtest-edit-preview-content">
                      <div class="p-abtest-edit-preview-content-row">
                        <div class="p-abtest-edit-preview-content__title">配信の設定</div>
                        <div class="p-abtest-edit-preview-content__text">予約配信</div>
                      </div>
                      <div class="p-abtest-edit-preview-content-row">
                        <div class="p-abtest-edit-preview-content__title">配信される日時</div>
                        <div class="p-abtest-edit-preview-content__text">{{ startDateTimeB }}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="p-abtest-detail-compare">
            <div class="p-abtest-detail-compare-list">
              <div class="p-abtest-detail-compare-list__item">
                <div class="p-abtest-detail-compare-row" :class="abtestResult.displayAWin ? 'p-abtest-detail-compare-row--victory' : ''" data-type="impression">
                  <div class="p-abtest-detail-compare-row__title">表示回数</div>
                  <div class="p-abtest-detail-compare-row__bar"><span :style="'width: ' + abtestResult.displayRatioA + '%;'"></span></div>
                  <div class="p-abtest-detail-compare-row__value">{{ abtestResult.displayA.toLocaleString() }}</div>
                </div>
                <div class="p-abtest-detail-compare-row" :class="abtestResult.clickAWin ? 'p-abtest-detail-compare-row--victory' : ''" data-type="click">
                  <div class="p-abtest-detail-compare-row__title">クリック数</div>
                  <div class="p-abtest-detail-compare-row__bar"><span :style="'width: ' + abtestResult.clickRatioA + '%;'"></span></div>
                  <div class="p-abtest-detail-compare-row__value">{{ abtestResult.clickA.toLocaleString() }}</div>
                </div>
                <div class="p-abtest-detail-compare-row" :class="abtestResult.clickRateAWin ? 'p-abtest-detail-compare-row--victory' : ''" data-type="ctr">
                  <div class="p-abtest-detail-compare-row__title">クリック率</div>
                  <div class="p-abtest-detail-compare-row__bar"><span :style="'width: ' + abtestResult.clickRateRatioA + '%;'"></span></div>
                  <div class="p-abtest-detail-compare-row__value">{{ abtestResult.clickRateA.toFixed(2) }}%</div>
                </div>
              </div>
              <div class="p-abtest-detail-compare-list__item">
                <div class="p-abtest-detail-compare-row" :class="abtestResult.displayBWin ? 'p-abtest-detail-compare-row--victory' : ''" data-type="impression">
                  <div class="p-abtest-detail-compare-row__title">表示回数</div>
                  <div class="p-abtest-detail-compare-row__bar"><span :style="'width: ' + abtestResult.displayRatioB + '%;'"></span></div>
                  <div class="p-abtest-detail-compare-row__value">{{ abtestResult.displayB.toLocaleString() }}</div>
                </div>
                <div class="p-abtest-detail-compare-row" :class="abtestResult.clickBWin ? 'p-abtest-detail-compare-row--victory' : ''" data-type="click">
                  <div class="p-abtest-detail-compare-row__title">クリック数</div>
                  <div class="p-abtest-detail-compare-row__bar"><span :style="'width: ' + abtestResult.clickRatioB + '%;'"></span></div>
                  <div class="p-abtest-detail-compare-row__value">{{ abtestResult.clickB.toLocaleString() }}</div>
                </div>
                <div class="p-abtest-detail-compare-row" :class="abtestResult.clickRateBWin ? 'p-abtest-detail-compare-row--victory' : ''" data-type="ctr">
                  <div class="p-abtest-detail-compare-row__title">クリック率</div>
                  <div class="p-abtest-detail-compare-row__bar"><span :style="'width: ' + abtestResult.clickRateRatioB + '%;'"></span></div>
                  <div class="p-abtest-detail-compare-row__value">{{ abtestResult.clickRateB.toFixed(2) }}%</div>
                </div>
              </div>
            </div>
          </div>
          <div class="p-abtest-detail__data">
            <div class="c-loader c-loader"></div>
            <table class="c-table c-table--abtest-detail">
              <thead>
                <tr>
                  <th class="c-table__cell--center u-w160">比較指標</th>
                  <th class="c-table__cell--center u-w250">合計数・平均</th>
                  <th class="c-table__cell--center u-w250">Aパターン</th>
                  <th class="c-table__cell--center u-w250">Bパターン</th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="abtestType == abtestInfo.abtestTypeValues.Demogra">
                  <th class="c-table__cell--left">配信対象数</th>
                  <td class="c-table__cell--right">{{ abtestResult.distribution.toLocaleString() }}</td>
                  <td class="c-table__cell--right">{{ abtestResult.distributionA.toLocaleString() }}</td>
                  <td class="c-table__cell--right">{{ abtestResult.distributionB.toLocaleString() }}</td>
                </tr>
                <tr>
                  <th class="c-table__cell--left">インプレッション</th>
                  <td class="c-table__cell--right">{{ abtestResult.display.toLocaleString() }}</td>
                  <td class="c-table__cell--right">{{ abtestResult.displayA.toLocaleString() }}</td>
                  <td class="c-table__cell--right">{{ abtestResult.displayB.toLocaleString() }}</td>
                </tr>
                <tr>
                  <th class="c-table__cell--left">クリック数</th>
                  <td class="c-table__cell--right">{{ abtestResult.click.toLocaleString() }}</td>
                  <td class="c-table__cell--right">{{ abtestResult.clickA.toLocaleString() }}</td>
                  <td class="c-table__cell--right">{{ abtestResult.clickB.toLocaleString() }}</td>
                </tr>
                <tr>
                  <th class="c-table__cell--left">クリック率</th>
                  <td class="c-table__cell--right">{{ abtestResult.clickRate.toFixed(2) }}%</td>
                  <td class="c-table__cell--right">{{ abtestResult.clickRateA.toFixed(2) }}%</td>
                  <td class="c-table__cell--right">{{ abtestResult.clickRateB.toFixed(2) }}%</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div class="l-main-content">
        <div class="p-abtest-detail__btns">
          <button
            class="c-btn c-btn--modal c-btn--blue u-w400 u-h50 u-fs--xl"
            :class="{ 'is-loading': isLoading }"
            :disabled="isLoading"
            type="button"
            name="edit"
            value="edit"
            @click="onCopyClick"
          >
            <p class="c-btn__text">この結果を引き継ぎテストを行う</p>
          </button>
          <div class="c-text">成果の良かった結果を元にさらに比較のテストを行うことができます。</div>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import 'axios';
export default {
  props: {
    csrfToken: String,
    abtestInfo: Object,
    abtestResult: Object,
    abtestType: String,
    abtest: Object,
    checkDate: String,
    breadcrumbData: Array,
  },
  data() {
    return {
      sortTargets: {
        deliverDate: 1,
        abtestType: 0,
        abtestName: 0,
        abtestStatus: 0,
      },
      abtests: null,
      paginationInfo: null,
      isLoading: false,
      currentAbtestName: null,
    }
  },
  computed: {
    messageA: function () {
      let message = null;
      if (this.abtest && this.abtest.abtest_messages.length > 0) {
        message = this.abtest.abtest_messages[0].message;
      }
      return message;
    },
    messageB: function () {
      let message = null;
      if (this.abtest && this.abtest.abtest_messages.length > 1) {
        message = this.abtest.abtest_messages[1].message;
      }
      return message;
    },
    topicConditionA: function() {
      let topicCondition = null;
      let message = this.messageA;
      if (message && message.topic_message_condition) {
        topicCondition = message.topic_message_condition.topic_condition;
      }
      return topicCondition;
    },
    topicConditionB: function() {
      let topicCondition = null;
      let message = this.messageB;
      if (message && message.topic_message_condition) {
        topicCondition = message.topic_message_condition.topic_condition;
      }
      return topicCondition;
    },
    startDateTimeA: function () {
      return this.getDisplayDateTime(this.messageA.message_deliver.send_start_date);
    },
    startDateTimeB: function () {
      return this.getDisplayDateTime(this.messageB.message_deliver.send_start_date);
    },
  },
  methods: {
    onCopyClick: function () {
      this.isLoading = true;
      location.href = this.abtestInfo.addUrl + '?type=copy&abtest_id=' + this.abtest.abtest_id;
    },
  }
}
</script>
